import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class FeaturesCount extends Field {
  static get disableFieldForModelNames() {
    return ['ReleasePhase'];
  }

  static attributesForModel() {
    return ['featuresCount'];
  }

  get title() {
    return `${terminology('Features')} count`;
  }

  exampleContents(): FieldContentsData {
    return { text: `3 ${terminology('features')}` };
  }

  contentsForRecord(record): FieldContentsData {
    return {
      text: `${record.featuresCount} ${terminology('features', {
        isPlural: record.featuresCount > 1,
      })}`,
    };
  }
}
